import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//Important note: If changing this file, make sure to temporarily disable vsc-organize-imports extension

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals()
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
